import React, { useState, useEffect } from 'react'
import styled from 'styled-components/macro'

const ResetFormContainer = styled.form`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
margin-top: 10rem;
`
const ButtonsContainer = styled.div`
display:flex;
flex-direction: row;`

const FormButton = styled.button`
margin: 0 1rem;
`


function PasswordTokenChange({ passwordRules, handleRequest, cancelRequest }) {


  const [passw, setPassw] = useState("")
  const [confirmField, setConfirmField] = useState("")
  const [passwordColor, setPasswordColor] = useState({ color: "black" })
  const [conformColor, setConformColor] = useState({ color: "red" })
  const [conformMsg, setConformMsg] = useState("")



  //This hook listens for changes to the new password box and displays a message if the password is too short
  useEffect(() => {
    if (passw.length < passwordRules.minLength) {
      setPasswordColor({ color: "red" })
      setConformMsg(`Minimum password length: ${passwordRules.minLength} characters`)

      return;
    } else {
      setConformMsg("")
      setPasswordColor({ color: "black" })
    }
  }, [passw, passwordRules.minLength])

  //This hook listens for changes to the confirm password box and changes the color based on whether it matches the new password
  useEffect(() => {
    if (passw === confirmField) {

      setConformColor({ color: "green" })
    }
    else {
      setConformColor({ color: "red" })
    }
  }, [confirmField, passw])

  //No need for event listeners here since this doesn't modify state. 
  function handleSubmit(event) {
    event.preventDefault();
    if (confirmField !== passw) {
      window.alert("New passwords must match")
    }
    else if (passw.length < passwordRules.minLength) {
      window.alert(conformMsg)
    }
    else {
      handleRequest(passw);
    }
  }

  function handleCancel() {
    cancelRequest();
  }




  return (
    <div className='swt-password-change-wrapper'>
      <ResetFormContainer id="pw-reset" onSubmit={handleSubmit}>
        <p className="swt-credential-input-label">New Password</p>
        <input
          className="swt-credential-input"
          name="password0"
          type="password"
          style={passwordColor}
          value={passw}
          onChange={(event) => { setPassw(event.target.value) }}
        ></input>
        <p id="swt-credential-msg-0" className="swt-credential-msg"></p>
        <p className="swt-credential-input-label">Confirm Password</p>
        <input
          className="swt-credential-input"
          name="password1"
          type="password"
          style={conformColor}
          value={confirmField}
          onChange={(event) => { setConfirmField(event.target.value) }}
        ></input>
        <p id="swt-credential-msg-1" className="swt-credential-msg">
          {conformMsg}
        </p>


        <ButtonsContainer>
          <FormButton
            className="swt-submit-button"
            type="reset"
            onClick={handleCancel}
          >
            Cancel
          </FormButton>
          <FormButton className="swt-submit-button" type="submit">
            Submit
          </FormButton>
        </ButtonsContainer>
      </ResetFormContainer>
    </div>
  );

}

export default PasswordTokenChange;
